<template>
    <div>
        <div
            class="model"
            style="margin-top: 0.20rem;"
            v-for="(item, index) in nexusRetailLevelOverview"
            :key="item.treeLevel"
        >
            <!-- 头部 -->
            <div class="model_header">
                <div class="flex">
                    <div class="flex1 text-align-left">
                        <span class="model_title">{{ memberScoreType[index] }} {{ item.nodeCount }} 人</span>
                    </div>
                    <div class="flex1 text-align-right retail">
                                         奖励总和：￥
                        {{ (item.scoreSum / 100).toFixed(2) }}
                    </div>
                </div>
            </div>
            <!-- 内容详情 -->
            <div class="flex margin">
                <div class="left flex1 flex"> 
                    <div class='detail'>
                        <img :src="nexusRetailLevelUsers.find(s => s.id === item.topScoreNode.nodeId).headUrl ?
                        nexusRetailLevelUsers.find(s => s.id === item.topScoreNode.nodeId).headUrl :
                        '../../../static/img/default.png'" alt="">
                    </div>
                    <div class="score left-score">
                        <span class="nick">
                            {{ nexusRetailLevelUsers.find(s => s.id === item.topScoreNode.nodeId).nick ?
                            nexusRetailLevelUsers.find(s => s.id === item.topScoreNode.nodeId).nick : 
                            '无'
                            }}
                        </span>
                        <p class="label">业绩冠军</p>
                    </div>
                </div>
                <div class="border"></div>
                <div class="right flex1">
                    <p class="score">
                        <span>个人</span>
                            {{ (item.topScoreNode.score / 100).toFixed(2) }}
                        
                    </p>
                    <p class="score">
                        <span>团队</span>
                        {{ (item.topScoreNode.sonScoreSum / 100).toFixed(2) }}
                        
                    </p>
                </div>
            </div>
        </div>
        <div v-if="nexusRetailLevelOverview.length === 0" class="empty">
            <img src="../../../static/img/empty.svg" alt="">
            <p class='nodata'>暂无更多信息</p>
        </div>
    </div>
</template>

<script>

export default {
  props: ['nexusRetailLevelUsers', 'nexusRetailLevelOverview', 'memberScoreType'],
  name: 'RetailTable',
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import './retail-team.scss';
</style>



// WEBPACK FOOTER //
// src/components/userMemberElement/RetailTable.vue